import { AfterViewInit, Component, ElementRef, forwardRef, ViewChild } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractControlDirective } from '@cupoui/shared/components/abstract-control.directive';
import { Location } from '@cupoui/shared/model/location';
// import Autocomplete = google.maps.places.Autocomplete;

@Component({
    selector: 'app-input-location',
    templateUrl: './input-location.component.html',
    styleUrls: ['./input-location.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            useExisting: forwardRef(() => InputLocationComponent),
            multi: true
        }
    ],
    standalone: false
})
export class InputLocationComponent extends AbstractControlDirective implements AfterViewInit {
  public locationControl: FormControl = new FormControl();

  @ViewChild('searchElement', { static: false }) public searchElementLocationRef: ElementRef;
  value: Location = new Location();

  private isValid = false;
  private locationSetByGoogle: boolean;

  constructor() {
    super();
    this.subscriptions.push(
      this.locationControl.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  ngAfterViewInit(): void {
    // const autocomplete = new Autocomplete(this.searchElementLocationRef.nativeElement, {}); // types: ['geocode']
    // autocomplete.addListener('place_changed', () => {
    //   const place = autocomplete.getPlace();
    //   this.getInformationFromGoogle(place);
    //   this.value.freeText = this.searchElementLocationRef.nativeElement.value;
    // });
  }

  public writeValue(value: Location | null): void {
    value = value === undefined ? null : value;
    this.locationControl.patchValue(value?.freeText, { emitEvent: false });
  }

  public setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.locationControl.disable({ emitEvent: false });
    } else {
      this.locationControl.enable({ emitEvent: false });
    }
  }

  private getInformationFromGoogle(place: any): void {
    if (place == null) {
      this.clearLocation();
      return;
    }
    if (!place.geometry) {
      return;
    }

    if (place.address_components === undefined) {
      this.clearLocation();
      this.locationSetByGoogle = false;
      this.isValid = false;
      return;
    }

    this.clearLocation();
    this.locationSetByGoogle = true;
    for (const address of place.address_components) {
      switch (address.types[0]) {
        case 'street_number':
          this.value.streetNumber = address.long_name;
          break;
        case 'route':
          this.value.streetName = address.long_name;
          break;
        case 'locality':
          this.value.locality = address.long_name;
          break;
        case 'administrative_area_level_1':
          this.value.administrativeAreaLevel1 = address.long_name;
          break;
        case 'administrative_area_level_2':
          this.value.administrativeAreaLevel2 = address.long_name;
          break;
        case 'country':
          this.value.country = address.long_name;
          this.value.countryCodeAlpha2 = address.short_name;
          break;
        case 'postal_code':
          this.value.postalCode = address.long_name;
          break;
      }
    }

    this.value.latitude = place.geometry.location.lat();
    this.value.longitude = place.geometry.location.lng();
    this.value.utcOffsetInHours = place.utc_offset_minutes ? place.utc_offset_minutes / 60 : 0;
  }

  private clearLocation(): void {
    this.locationSetByGoogle = false;
    this.value.streetNumber = '';
    this.value.streetName = '';
    this.value.locality = '';
    this.value.administrativeAreaLevel1 = '';
    this.value.administrativeAreaLevel2 = '';
    this.value.country = '';
    this.value.postalCode = '';
    this.value.latitude = 0;
    this.value.longitude = 0;
    this.value.timeZoneId = '';
    this.value.utcOffsetInHours = 0;
    this.isValid = false;
    this.value.countryCodeAlpha2 = '';
  }
}
